const ReportsPage = () => <div><h1 className="text-2xl font-bold text-emerald-900">Financial Reports</h1><p>Reports page...</p></div>; export default ReportsPage
